// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa1.dev.cmona.de/auto-open-api-spec.yaml 1.9.0
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for PrescriptionSetMedicine Model Structure.
 * @see #/components/schemas/PrescriptionSetMedicationRequest - reference to schema in open-api-spec.yaml
 * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
 * @version 1.9.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface PrescriptionSetMedicationRequest {
    /**
     * Prescription Set ID
     * @dataFormat uuid
     */
    prescription_set_id: string;
    standard_medication_set: string;
    /**
     * The instructions for prescription set medication.
     *
     */
    instructions?: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for PrescriptionSetMedicationRequest
 */
export namespace PrescriptionSetMedicationRequest {
    /**
     * PrescriptionSetMedicationRequest Frontend Model with camelCase properties
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * Prescription Set ID
         * @dataFormat uuid
         */
        prescriptionSetId: string;
        standardMedicationSet: string;
        /**
         * The instructions for prescription set medication.
         * @type string (`dataFormat` is missing)
         */
        instructions?: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * PrescriptionSetMedicationRequest DTO
     * Transforms PrescriptionSetMedicationRequest model from/to API object
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend PrescriptionSetMedicationRequest model */
        static toModel(obj: PrescriptionSetMedicationRequest): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend PrescriptionSetMedicationRequest model */
        static toApi(obj: Model): PrescriptionSetMedicationRequest {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as PrescriptionSetMedicationRequest;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
